import React, { Component } from 'react';
import { injectIntl, FormattedMessage } from 'react-intl';
import { Button, Modal, ModalFooter } from 'reactstrap';
import { ErrorAlert } from '../ErrorAlert';
import BlockUi from 'react-block-ui';

class ConfirmActionModal extends Component {
    render() {
        const { block, error, text, toggleModal, modal, actionFunction, children } = this.props;

        return (
            <Modal isOpen={modal} toggle={toggleModal} fade={false} className="modal-md" style={{ minWidth: 0, marginTop: '15%' }}>
                <form onSubmit={this.submitForm}>
                    <BlockUi tag="div" blocking={block}>
                        <ErrorAlert error={error} />

                        <div className="text-center py-4 px-2">
                            {text}
                        </div>

                        {children}

                        <ModalFooter className="py-2 border-0">
                            <Button className={`btn btn-sm btn-host submit`} onClick={(e) => actionFunction(e)}>
                                <FormattedMessage id="generic.Confirm" />
                            </Button>
                            <Button className="btn btn-sm" onClick={toggleModal} type='button'>
                                <FormattedMessage id="generic.cancel" />
                            </Button>
                        </ModalFooter>
                    </BlockUi>
                </form>
            </Modal>
        );
    }
}
export default injectIntl(ConfirmActionModal)
